import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import useSEO from "../hooks/useSEO";
import Reveal from "../components/Reveal";
import "./Faq.css";

const faqs = [
  {
    question: "Posso fare le sedute online?",
    answer:
      "Sì, le sedute possono svolgersi su Google Meet. Riceverai il link e le indicazioni pratiche subito dopo la prenotazione.",
  },
  {
    question: "Quanto dura un incontro?",
    answer: "Una seduta dura circa 45 minuti, sia in studio sia online.",
  },
  {
    question: "Ogni quanto ci vediamo?",
    answer:
      "Dipende dall'obiettivo e dal momento che stai vivendo: in genere 1 incontro a settimana o ogni 2 settimane.",
  },
  {
    question: "Serve una prescrizione medica?",
    answer:
      "No, puoi prenotare direttamente un colloquio senza prescrizione. Se necessario, ci possiamo coordinare con altri specialisti.",
  },
  {
    question: "Tratti anche adolescenti?",
    answer:
      "Sì, offro supporto psicologico a adolescenti e adulti, con approcci calibrati per età ed esigenze.",
  },
];

const Faq = () => {
  useSEO({
    title: "La Psicologa Anna | Domande frequenti",
    description:
      "FAQ su sedute online, durata degli incontri e servizi offerti dalla Dott.ssa Anna Antoniozzi.",
    canonicalPath: "/faq",
  });

  useEffect(() => {
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: { "@type": "Answer", text: item.answer },
      })),
    };
    let script = document.getElementById("faq-schema");
    if (!script) {
      script = document.createElement("script");
      script.id = "faq-schema";
      script.type = "application/ld+json";
      document.head.appendChild(script);
    }
    script.text = JSON.stringify(schemaData);
    return () => { if (script) script.remove(); };
  }, []);

  return (
    <div className="faq">
      <section className="section section--paper faq-hero">
        <div className="container container--narrow">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          >
            <p className="eyebrow">Domande frequenti</p>
            <h1 className="display faq-title">Le risposte che ti servono prima di iniziare</h1>
            <p className="lead">Informazioni rapide su modalità, durata delle sedute e servizi offerti.</p>
          </motion.div>
        </div>
      </section>

      <section className="section--tight">
        <div className="container container--narrow">
          <div className="faq-list">
            {faqs.map((item, i) => (
              <Reveal key={item.question} delay={i * 0.04}>
                <details className="faq-item">
                  <summary>{item.question}</summary>
                  <p>{item.answer}</p>
                </details>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="cta-band">
        <div className="container cta-band__inner">
          <Reveal>
            <h2 className="display cta-band__title">Non hai trovato la tua risposta?</h2>
            <p className="cta-band__text">Scrivimi: sarò felice di chiarire ogni dubbio.</p>
            <div className="cta-band__actions">
              <Link to="/contatti" className="btn btn--accent">
                Contattami <ArrowRight className="btn-arrow" size={18} />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Faq;
